import { useRef } from 'react';

export const useProductCache = () => {
  const productsCacheRef = useRef({});

  const saveProductsInCache = (products) => {
    products.forEach((product) => {
      productsCacheRef.current[product.itemId] = product;
    });
  };

  const getProductFromCache = (productId) => {
    return productsCacheRef.current[productId];
  };

  return { saveProductsInCache, getProductFromCache };
};